import React from "react";
import "./i18n"; // Import the i18n configuration
import "./styles/global.css"; // Import global styles
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import ProjectsGallery from "./components/ProjectsGallery";
import ContactForm from "./components/ContactForm";
import StickyButton from "./components/StickyButton";
import Location from "./components/Location";
import Footer from "./components/footer";

function App() {
  return (
    <div className="app">
      {/* Header with language switcher */}
      <Header />

      {/* Hero Section */}
      <Hero />

      {/* About Section */}
      <About />

      {/* Projects Gallery Section */}
      <ProjectsGallery />

      {/* Location Section */}
      <Location />

      {/* Contact Form Section */}
      <ContactForm />

      {/* Footer Section */}
      <Footer />

      {/* Sticky Contact Button */}
      <StickyButton />
    </div>
  );
}

export default App;
